import React from "react";
const INITIAL_STATE = {
  title: "",
  variant: "info",
  platformResponse: null,
  payload: "",
  header: ""
};
export const useNotifications = () => {
  const [notification, setNotification] = React.useState(INITIAL_STATE);
  const addSuccessNotification = (title, header = "") => {
    setNotification({
      title,
      variant: "success",
      header
    });
  };
  const addFailureNotification = (title, header = "") => {
    setNotification({
      title,
      variant: "error",
      header
    });
  };
  const addFailureNotificationWithNoDuration = (title, payload, duration = null, header = "") => {
    setNotification({
      title,
      variant: "error",
      payload,
      duration,
      header
    });
  };
  const addInfoNotification = (title, duration, header = "") => {
    setNotification({
      title,
      variant: "info",
      duration,
      header
    });
  };
  const clearNotification = () => {
    setNotification({
      ...INITIAL_STATE,
      variant: notification.variant
    });
  };
  return {
    notification,
    addSuccessNotification,
    addFailureNotification,
    addFailureNotificationWithNoDuration,
    addInfoNotification,
    clearNotification
  };
};